import {
  API_ENDPOINT,
  useClientApiV1MarketingPartnersCreateMutation,
} from '../../resources/@types/courseSchema';

interface UseClientV1MarketingPartnersMutation {
  options?: Parameters<typeof useClientApiV1MarketingPartnersCreateMutation>[0]['options'];
}

export function useMarketingPartnersCreateMutation({
  options,
}: UseClientV1MarketingPartnersMutation) {
  return useClientApiV1MarketingPartnersCreateMutation({
    url: API_ENDPOINT.CLIENT_V1_MARKETING_PARTNERS,
    options,
  });
}
